<template>
  <div class="headerBoxResume row no-gutters">
    <span class="headerBoxResume_text">{{ ` ${this.text} ` }}</span>
    <span class="headerBoxResume_info"
          :class="{hideMe: !this.info}">{{ ` ${this.info} ` }}</span>
  </div>
</template>

<script>
  export default {
    name: "HeaderBoxResume",
    props: ['info', 'text'],
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .headerBoxResume {
    color: white;
    font-size: pxToRem(14);
    font-weight: 500;
    max-width: 7.5rem;

    &_text,
    &_info {
      display: inline-block;
      line-height: pxToRem(14);
      min-height: pxToRem(14);
      width: 100%;
    }

    &_text {
       border-bottom: 0.0625rem solid white;
       padding-top: 7px;
       padding-bottom: 2px;
       margin-bottom: 2px;
    }

    &_info {
      word-break: break-all;

    }
  }
  .matricula_id{
     max-width: 18rem;
  }
.resumeTitle{
  position: relative;
  top: 35px;
  }
.typeIcon{
  position: relative;
  bottom: 5px;
  font-size: 22px;
}

  .hideMe {
    visibility: hidden;
  }
</style>
